<template>
  <div class="wrapper">
      <video ref="video" id="video" class="video-js vjs-default-skin vjs-big-play-centered" autoplay preload="auto"></video>
      <!-- <div id="controls">
        <div id="buttons">
          <div class="btn-media btn-backward" v-on:click="keyRewind"><icon name="backward" scale="3"></icon></div>
          <div class="btn-media btn-play" v-on:click="keyEnter"><icon name="play" scale="3"></icon></div>
          <div class="btn-media btn-forward" v-on:click="keyForward"><icon name="forward" scale="3"></icon></div>
        </div>
      </div> -->
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import videojs from 'video.js'
import {StatsCategoryTailler} from '@/utils/constants'
const contentsService = require('@/services/contents.js')

export default {
  name: 'CategoryTrailer',
  data () {
    return {
      category: {},
      videoPlayer: null
      // progress: 0
    }
  },
  created: function () {
    // CATEGORÍA
    contentsService.getCategory(this.$route.params.id).then(response => {
      this.category = response.data
      this.initPlayer()
      window.Countly.q.push(['track_pageview', StatsCategoryTailler + ' ' + this.category.id + ': ' + this.category.name])
    })

    // control keys
    Bus.$on('key-enter', this.keyEnter)
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-play-pause', this.keyEnter)
    Bus.$on('key-pause', this.keyPause)
    Bus.$on('key-play', this.keyPlay)
    Bus.$on('key-rewind', this.keyRewind)
    Bus.$on('key-forward', this.keyForward)
  },
  methods: {
    initPlayer: function () {
      // src
      // this.$refs.video.setAttribute('src', '')
      // this.$refs.video.load()
      // this.$refs.video.play()
      this.videoPlayer = videojs(this.$refs.video, {
        // techOrder: ["html5", "flash", "youtube"],
        controls: true,
        controlBar: {
          progressControl: true,
          fullscreenToggle: false,
          volumeControl: false,
          volumeMenuButton: false
        }
      }, () => {
        this.setSrc(this.category.trailer)
      })
    },
    setSrc: function (src) {
      this.videoPlayer.src({type: 'video/mp4', src: src})
    },
    keyEnter: function () { if (this.videoPlayer) { this.videoPlayer.paused() ? this.videoPlayer.play() : this.videoPlayer.pause() } },
    keyPause: function () { if (this.videoPlayer) this.videoPlayer.pause() },
    keyPlay: function () { if (this.videoPlayer) this.videoPlayer.play() },
    keyRewind: function () { if (this.videoPlayer) this.videoPlayer.currentTime(this.videoPlayer.currentTime() - 10) },
    keyForward: function () { if (this.videoPlayer) this.videoPlayer.currentTime(this.videoPlayer.currentTime() + 10) },
    // keyEnter: function () { this.$refs.video.paused ? this.$refs.video.play() : this.$refs.video.pause() },
    // keyPause: function () { this.$refs.video.pause() },
    // keyPlay: function () { this.this.$refs.video.play() },
    // keyRewind: function () { this.$refs.video.currentTime = this.$refs.video.currentTime - 10 },
    // keyForward: function () { this.$refs.video.currentTime = this.$refs.video.currentTime + 10 }
    keyBack: function () { this.$router.go(-1) }
  },
  beforeDestroy: function () {
    Bus.$off('key-enter', this.keyEnter)
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-play-pause', this.keyEnter)
    Bus.$off('key-pause', this.keyPause)
    Bus.$off('key-play', this.keyPlay)
    Bus.$off('key-rewind', this.keyRewind)
    Bus.$off('key-forward', this.keyForward)
    if (this.videoPlayer) this.videoPlayer.dispose()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  z-index: 10;
  background-color: #000000

#video
  width: 100vw
  height: 100vh

// #controls
//   background-color: rgba(0,0,0,.3)
//   position: absolute
//   left: 0
//   bottom: 0
//   width: 100vw
//   height: 12vh
//   padding: 1rem

//   #progress-bar
//     width: 100%

//   #buttons
//     width: 100%
//     height: 100%
//     display: flex
//     flex-direction: row
//     justify-content: center
//     align-items: center
//     color: #FAFAFA

//     .btn-media
//       margin: 1rem
//       cursor: pointer

//     .btn-play
//       margin: 1rem 2.5rem 1rem 2.5rem
</style>



// WEBPACK FOOTER //
// src/pages/contents/CategoryTrailer.vue